import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import GraphViewer from "../../../../components/GraphPlotter/GraphViewer";
import FractionInput from "../../../../components/inputs/FractionInput";

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function buildTaskData() {
  const xRange = [-6, 6];
  const yRange = [-6, 6];

  for (let attempt = 0; attempt < 500; attempt++) {
    const a = randInt(-3, 3);
    const b = randInt(-4, 4);
    const candidates = [];

    for (let x = -5; x <= 5; x++) {
      const y = a * x + b;
      if (Number.isInteger(y) && y >= -5 && y <= 5) {
        candidates.push({ x, y });
      }
    }

    if (!candidates.length) continue;

    const chosen = candidates[randInt(0, candidates.length - 1)];
    if (Math.abs(chosen.x) === 6 || Math.abs(chosen.y) === 6) continue;

    return {
      a,
      b,
      x: chosen.x,
      y: chosen.y,
      xRange,
      yRange,
    };
  }

  return {
    a: 1,
    b: 0,
    x: 2,
    y: 2,
    xRange: [-6, 6],
    yRange: [-6, 6],
  };
}

export function generateTask() {
  return {
    type: "LinearValueFromGraphTask",
    data: buildTaskData(),
  };
}

export function renderTask({ data }) {
  return (
    <div className="space-y-3">
      <p>
        Na wykresie przedstawiono funkcje liniowa <InlineMath math="f(x)" />.
        Odczytaj wartosc <InlineMath math={`f(${data.x})`} />.
      </p>

      <div style={{ maxWidth: 360 }}>
        <GraphViewer
          width={360}
          equations={[`y = ${data.a}*x + (${data.b})`]}
          points={{}}
          segments={[]}
          xRange={data.xRange}
          yRange={data.yRange}
        />
      </div>
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return (
    <div className="flex gap-4 items-center flex-wrap">
      <div className="flex items-center gap-2">
        <span><InlineMath math={`f(${task.data.x}) = `} /></span>
        <FractionInput
          value={userAnswer || ""}
          onChange={(val) => onChange({ ...val, xValue: task.data.x })}
          disabled={disabled}
          label={`f(${task.data.x})`}
        />
      </div>
    </div>
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  if (!Number.isFinite(userAnswer.parsed)) return false;
  return Math.abs(userAnswer.parsed - data.y) < 0.005;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  const xValue = userAnswer.xValue;
  if (xValue == null) {
    return <InlineMath math={userAnswer.raw} />;
  }
  return <InlineMath math={`f(${xValue}) = ${userAnswer.raw}`} />;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`f(${data.x}) = ${data.y}`} />;
}

export function renderExplanation({ data }) {
  return (
    <div className="space-y-2" style={{ textAlign: "left" }}>
      <p><strong>Krok 1:</strong> Na osi <InlineMath math="x" /> zaznaczamy argument <InlineMath math={`${data.x}`} />.</p>
      <p><strong>Krok 2:</strong> Idziemy pionowo do wykresu i odczytujemy odpowiadajaca wartosc na osi <InlineMath math="y" />.</p>
      <BlockMath math={`f(${data.x}) = ${data.y}`} />
    </div>
  );
}

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};





